import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "borderRadius"];
import { ProgressBar } from './ProgressBar';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProgressBarBreeze = _ref => {
  let {
      size = 'xs',
      borderRadius = 'border-radius-sm'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ProgressBar, Object.assign({}, rest, {
    borderRadius: borderRadius,
    size: size,
    variant: "breeze"
  }));
};